import { render, staticRenderFns } from "./sopDetail.vue?vue&type=template&id=91f49450&scoped=true&"
import script from "./sopDetail.vue?vue&type=script&lang=js&"
export * from "./sopDetail.vue?vue&type=script&lang=js&"
import style0 from "./sopDetail.vue?vue&type=style&index=0&id=91f49450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f49450",
  null
  
)

export default component.exports